export default "__VITE_ASSET__Di6iP1jQ__"